import ManagerGiftCreate from './ManagerGiftCreate.container';

export default ManagerGiftCreate;
